module.exports = __webpack_public_path__ + "img/hover-instagram.12ae20ee.svg";